/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Csvkontoinhaber1Inputs */



/**

* @param {_Field_Csvkontoinhaber1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_csvkontoinhaber1 = /** @type {((inputs?: _Field_Csvkontoinhaber1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Csvkontoinhaber1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Kontoinhaber laut Datei")
});
export { _field_csvkontoinhaber1 as "_field_csvKontoinhaber" }